<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_supplier_name_cn') || '供应商名称'"
            prop="scmName"
          >
            <el-input
              v-model="formData.scmName"
              maxlength="500"
              :disabled="diversityFlag"
              :placeholder="
                $l('form_label_supplierName_tips') || '请输入供应商名称'
              "
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_supplier_name_en') || '供应商英文名称'"
            prop="scmNameEn"
          >
            <el-input
              v-model="formData.scmNameEn"
              maxlength="500"
              :disabled="diversityFlag"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_cooperation_status') || '合作状态'"
            prop="isCooperation"
          >
            <el-input
              v-model="formData.isCooperationName"
              disabled
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_province') || '省'"
            prop="provinceCode"
          >
            <el-select
              size="mini"
              v-model="formData.provinceCode"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              @change="loadCityOptions"
              filterable
              clearable
              :disabled="diversityFlag"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_city') || '市'" prop="cityCode">
            <el-select
              size="mini"
              v-model="formData.cityCode"
              @change="loadDistrictOptions"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
              :disabled="diversityFlag"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_area') || '区/县'"
            prop="districtCode"
          >
            <el-select
              size="mini"
              v-model="formData.districtCode"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
              :disabled="diversityFlag"
            >
              <el-option
                v-for="item in districtOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_address_detail') || '详细地址'"
            prop="scmAddress"
          >
            <el-input
              v-model="formData.scmAddress"
              maxlength="500"
              :placeholder="
                $l('form_label_addressDetail_tips') || '请填写详细地址'
              "
              clearable
              :disabled="diversityFlag"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('scm_info_scmAddressEn') || '详细地址(英文)'"
          >
            <el-input
              v-model="formData.scmAddressEn"
              maxlength="500"
              :placeholder="
                $l('tips_input_scm_info_scmAddressEn') || '请填写详细地址(英文)'
              "
              clearable
              :disabled="diversityFlag"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('form_label_supply_chain_vendor_type') || '供应链厂商类型'
            "
            prop="scmType"
          >
            <dict-select
              filterable
              size="mini"
              clearable
              :disabled="
                (this.formData.oaRequestScmMode != '' &&
                  this.formData.oaRequestScmMode != null) ||
                  this.formData.scmMode != 'A'
              "
              v-model="formData.scmType"
              :placeholder="
                $l('form_label_pe_supply_chain_vendor_type') ||
                  '请选择供应链厂商类型'
              "
              :body="scmTypeParams"
              url="/digitalCenter/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_supply_chain_model') || '供应链厂商合作模式'"
            prop="scmMode"
          >
            <dict-select
              filterable
              size="mini"
              clearable
              disabled
              v-model="formData.scmMode"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :body="scmModeParams"
              url="/digitalCenter/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_supplier_category') || '厂商类别'"
          >
            <el-select
              size="mini"
              v-model="formData.scmCategoryCode"
              @change="selTemplateByScmCategoryCode"
              style="width: 100%"
              filterable
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_supplier_businessLicense') || '统一社会征信代码'
            "
            prop="businessLicense"
          >
            <el-input
              v-model="formData.businessLicense"
              maxlength="500"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              :disabled="diversityFlag"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_certificate_info') || '相关证书'"
            prop="certificateInfoArray"
          >
            <el-select
              v-model="formData.certificateInfoArray"
              :disabled="disabled"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in certificateInfoOptions"
                :key="item.code"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_factory_inspection') || '工厂资质'"
            prop="factoryInspectionArray"
          >
            <el-select
              v-model="formData.factoryInspectionArray"
              :disabled="disabled"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in factoryInspectionOptions"
                :key="item.code"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_customer') || '适用客户'"
            prop="suitableForCustomersArray"
          >
            <el-select
              v-model="formData.suitableForCustomersArray"
              :disabled="disabled"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in suitableForCustomersOptions"
                :key="item.value"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_supplier_source') || '供应商来源'"
            prop="scmSource"
          >
            <el-select
              v-model="formData.scmSource"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in scmSourceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_main_categories') || '主要品类'">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.scmProductCategory"
              clearable
              size="mini"
              :placeholder="
                $l('INDEX.tips_input_placeholder_categories') ||
                  '请输入合作意愿、配合度、专业性'
              "
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_remarks') || '工厂概况'">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.scmMemo"
              clearable
              size="mini"
              :placeholder="
                $l('INDEX.tips_input_placeholder_factory') ||
                  '请输入工厂整体情况：年销售额、总产能、目前产能占比等背景情况'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_cooperation') || '合作意向'">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.scmCooperation"
              clearable
              size="mini"
              :placeholder="
                $l('INDEX.tips_input_placeholder_cooperation') ||
                  '请输入合作意愿、配合度、专业性'
              "
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_main_recommendation') || '推荐指数'"
          >
            <br />
            <el-rate v-model="formData.ourRatings"> </el-rate>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <Attribute size="mini" :span="8" ref="attribute" :params="attrParams" />
      </el-row>
      <el-row>
        <ScmBankTable
          :disabled="diversityFlag"
          :scmCode="scmCode"
          ref="scmBank"
        />
      </el-row>
      <el-row v-if="this.pageType === 'apply'">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_zzyy') ||'转正原因'" prop="zzyy">
            <el-input
              v-model="formData.zzyy"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="mt-2 d-flex justify-content-start">
        <div>
          <el-button
            type="primary"
            size="mini"
            @click="save()"
            v-if="this.pageType !== 'apply'"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="updateScmMode('B')"
            v-if="
              this.pageType === 'apply' &&
                this.scmModeFalg === 'A' &&
                this.formData.scmType != 'B'
            "
            >{{
              $l('form_label_convert_to_potential_supplier') || '转为潜在供应商'
            }}</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="updateScmMode('C')"
            v-if="this.pageType === 'apply'"
            >{{
              $l('form_label_convert_to_formal_supplier') || '转为正式供应商'
            }}</el-button
          >
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import Attribute from '@/views/digital/components/attribute'
import validate from '@/libs/util.validate'
import ScmBankTable from './scmBank-table/table'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  components: { Attribute, ScmBankTable },
  props: {
    scmCode: String,
    pageType: String,
    diversity: String,
  },
  data() {
    return {
      scmTypeParams: { dictType: 'scmType' },
      scmModeParams: { dictType: 'scmMode' },
      disabled: false,
      cityValid: false,
      districtValid: false,
      scmModeFalg: '',
      diversityFlag: false,

      formData: {
        ourRatings: 0,
        districtCode: '',
        scmMode: 'A',
      },
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      categoryOptions: [], // 供应商类别下拉
      factoryInspectionOptions: [], //工厂资质
      certificateInfoOptions: [], //证书类型
      suitableForCustomersOptions: [], //适用客户
      scmSourceOptions: [],
      rules: {
        scmName: [
          {
            required: true,
            message:
              this.$l('form_label_supplierName_tips') || '请输入供应商名称',
            trigger: 'blur',
          },
        ],
        scmType: [
          {
            required: true,
            message:
              this.$l('form_label_pe_supply_chain_vendor_type') ||
              '请选择供应链厂商类型',
            trigger: 'blur',
          },
        ],
        zzyy: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    scmCode: {
      handler(scmCode) {
        if (scmCode !== '') {
          this.init()
        }
      },
      immediate: true,
    },
  },
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.scmCode,
        templateCategoryCode: this.formData.scmCategoryCode,
        masterCategoryCode: this.formData.scmCategoryCode,
        templateType: 'S',
      }
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async init() {
      this.reset()
      await this.loadDetail()
      this.loadCategoryOptions()
      this.loadProvinceOptions()
    },
    async loadDetail() {
      if (!this.scmCode) return
      return this.$api
        .scmInfoDetailApi({ scmCode: this.scmCode })
        .then((res) => {
          this.formData = {
            ...res.body,
            ourRatings: parseFloat(res.body.ourRatings),
          }
          this.scmModeFalg = this.formData.scmMode
          // if (this.diversity === 'ordinary') {
          this.diversityFlag = this.formData.scmMode != 'A'
          // }
          this.$refs.attribute.load(this.attrParams)
        })
    },
    // 省份下拉
    loadProvinceOptions() {
      let regionDictParam = { levelType: '1', parentId: '0' }
      // 省份下拉
      this.$api
        .baseRegion(regionDictParam)
        .then((res) => {
          this.provinceOptions = res.body.data
          this.loadCityOptions()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 市级下拉
    loadCityOptions() {
      let regionDictParam = {
        levelType: '2',
        parentId: this.formData.provinceCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.cityOptions = res.body.data
          // 当省级发生变化时,清空市县
          if (this.cityValid) {
            this.formData.cityCode = ''
            this.formData.districtCode = ''
          }
          this.loadDistrictOptions()
          this.cityValid = true
        })
      } else {
        this.formData.cityCode = ''
        this.formData.districtCode = ''
        this.cityOptions = []
        this.districtOptions = []
      }
    },
    // 县级下拉
    loadDistrictOptions() {
      let regionDictParam = {
        levelType: '3',
        parentId: this.formData.cityCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.districtOptions = res.body.data
          // 当市级发生变化时,清空区县
          if (this.districtValid) {
            this.formData.districtCode = ''
          }
          this.districtValid = true
        })
      } else {
        this.formData.districtCode = ''
        this.districtOptions = []
      }
    },
    // 获取供应商类别下拉
    loadCategoryOptions() {
      this.$api
        .scmCategoryOptionApi({})
        .then((res) => {
          this.categoryOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })

      //工厂资质下拉
      this.$api
        .bizDict({ dictType: 'factoryInspectionCode' })
        .then((res) => {
          this.factoryInspectionOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })

      //证书类型下拉
      this.$api
        .bizDict({ dictType: 'certificateInfoCode' })
        .then((res) => {
          this.certificateInfoOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })

      //适用客户下拉
      this.$api
        .masterTargetCustomer_attributesSelect()
        .then((res) => {
          this.suitableForCustomersOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
      //供应商来源下拉
      this.$api
        .bizDict({ dictType: 'scmSource' })
        .then((res) => {
          this.scmSourceOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 根据供应商类别查询供应商属性输入模板接口
    selTemplateByScmCategoryCode() {
      let scmInputTemplateParam = {
        scmCategoryCode: this.formData.scmCategoryCode,
      }
      this.$api
        .scmInputTemplateSelTemByScmCategoryCodeApi(scmInputTemplateParam)
        .then((res) => {
          this.scmInputTemplateData = res.body
          if (this.scmInputTemplateData === null) {
            // this.$message.info('此类别暂无供应商属性输入模板')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 转正申请
    regularApply(val) {
      this.$api
        .scmInfoAppleApi({
          scmCode: val,
          linkUrl: this.$joinURL(`/opview/scm/${val}`, {
            joinOrigin: true,
            joinBasePath: false,
          }),
        })
        .then(() => {
          this.loadingClose()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //普通的供应商保存
    save() {
      const form = this.$refs.formData
      const attrForm = this.$refs.attribute.$refs.form
      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.formData.attrData = this.$refs.attribute.getFormData()
          this.$api
            .scmInfoSaveApi(this.formData)
            .then((res) => {
              this.formData.scmCode = res.body
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success',
              })
              this.loadingClose()
              // if (this.pageType === 'add') {
              this.$emit('saveSuccess', res.body)
              // }
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    // 保存并提交申请
    saveSubmit() {
      const form = this.$refs.formData
      const attrForm = this.$refs.attribute.$refs.form
      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.formData.attrData = this.$refs.attribute.getFormData()
          this.$api
            .scmInfoSaveApi(this.formData)
            .then((res) => {
              this.formData.scmCode = res.body
              this.regularApply(res.body)
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_apple_ok') || '申请成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    updateScmMode(val) {
      if (!this.formData.scmName) {
        this.$message({
          showClose: true,
          message:
            this.$l('form_label_supplierName_tips') || '请输入供应商名称',
          type: 'warning',
        })
        return
      }
      if (
        !this.formData.provinceCode ||
        !this.formData.cityCode ||
        !this.formData.districtCode
      ) {
        this.$message({
          showClose: true,
          message:
            this.$l('form_label_pe_provinces_cities_counties') ||
            '请选择省市区',
          type: 'warning',
        })
        return
      }

      if (!this.formData.scmAddress) {
        this.$message({
          showClose: true,
          message: this.$l('form_label_addressDetail_tips') || '请填写详细地址',
          type: 'warning',
        })
        return
      }
      if (!this.formData.scmType) {
        this.$message({
          showClose: true,
          message:
            this.$l('form_label_pe_supply_chain_vendor_type') ||
            '请选择供应链厂商类型',
          type: 'warning',
        })
        return
      }
      if (!this.formData.businessLicense) {
        this.$message({
          showClose: true,
          message:
            this.$l('form_label_supplierBusinessLicense_tips') ||
            '请输入统一社会征信代码',
          type: 'warning',
        })
        return
      }
      var table = this.$refs.scmBank.getTableData()
      if (!table || table.length == 0) {
        this.$message.warning('请添加银行账号信息')
        return
      }

      if (val === 'C' && this.formData.scmType === 'A') {
        if (!this.formData.certificateInfoArray) {
          this.$message({
            showClose: true,
            message:
              this.$l('form_label_pe_select_the_relevant_certificate') ||
              '请选择相关证书',
            type: 'warning',
          })
          return
        }
        if (!this.formData.factoryInspectionArray) {
          this.$message({
            showClose: true,
            message:
              this.$l('form_label_pe_select_factory_qualification') ||
              '请选择工厂资质',
            type: 'warning',
          })
          return
        }
      }
      this.formData.oaRequestScmMode = val
      this.saveSubmit()
    },

    reset() {
      this.cityValid = false
      this.districtValid = false
      this.factoryInspectionOptions = [] //工厂资质
      this.certificateInfoOptions = [] //证书类型
      this.suitableForCustomersOptions = [] //适用客户
      this.scmSourceOptions = [] //供应商来源
      this.formData = {
        scmCode: '',
        scmNo: '',
        scmName: '',
        scmNameEn: '',
        scmCategoryCode: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        scmAddress: '',
        scmImageCode: '',
        scmImageUrl: '',
        scmThumbImageCode: '',
        scmThumbImageUrl: '',
        scmMemo: '',
        scmStatus: '',
        scmStatusName: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyDate: '',
        modifyByName: '',
        scmCooperation: '',
        scmCategoryName: '',
        scmScore: '',
        isCooperation: '',
        isCooperationName: '',
        visits: '',
        createDateEn: '',
        businessLicense: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        bankAccountKind: '',
        // certificateInfo: '',
        certificateInfoArray: [], //证书类型
        factoryInspectionArray: [], //工厂资质
        suitableForCustomersArray: [], //适用客户
        ourRatings: 0,
        scmProductCategory: '',
        scmMode: 'A',
        scmType: '',
        oaRequestScmMode: '',
      }
    },
  },
}
</script>
